export default {
    SET_USER_DEPARTMENTS(state, userDepartments) {
        state.userDepartments = userDepartments
    },
    ADD_USER_DEPARTMENT(state, userDepartment) {
        state.userDepartments.unshift(userDepartment)
    },
    UPDATE_USER_DEPARTMENT(state, userDepartment) {
        const userDepartmentIndex = state.userDepartments.findIndex((w) => w.id === userDepartment.id)
        Object.assign(state.userDepartments[userDepartmentIndex], userDepartment)
    },
    DELETE_USER_DEPARTMENT(state, userDepartmentId) {
        const ItemIndex = state.userDepartments.findIndex((w) => w.id === userDepartmentId)
        state.userDepartments.splice(ItemIndex, 1)
    },
    ADD_DEPARTMENT_SCHEDULE(state, schedule) {
      const itemIndex = state.userDepartments.findIndex((w) => w.id === schedule.user_department_id)

      if (itemIndex !== -1){
        state.userDepartments[itemIndex]['schedule'] = schedule
      }
    },
    DELETE_DEPARTMENT_SCHEDULE(state, userDepartmentsId) {
      const userDepartments = state.userDepartments.filter(department => userDepartmentsId.includes(department.id))
      userDepartments.forEach((department, idx) => {
        state.userDepartments[idx]['schedule'] = null;
      })
    }
}
